var Products = {
	// properties
	allowed_limits: {},
	catalogs: {},
	data: {},
	defaults: {},
	downloads: {},
	limits: [],
	filters: {
		degree_of_protection: 'all',
		max_payload: 'all',
		pnp_or_npn: 'PNP',
		standard_or_ul: 'all',
		z_travel: 'all'
	},
	partnumber: '', // single part number to search for
	partnumbers: [], // part numbers for a given product series, in json format for autocomplete
	pn_specs: {}, // specs for a given part number
	products_count: 0, // count of the products
	products: {}, // all products to parse and draw
	reach: null,
	series: [],

	// methods
	drawCatalogs: function() {
		console.debug('called', arguments.callee.name);

		const template = $('#catalog_template').html();
		const handlebars_template = Handlebars.compile(template);
		const result = handlebars_template(this.catalogs);
		const html = result;

		$('#div_catalogs').html(html);

		return this;
	},
	drawDownloads: function() {
		console.debug('called', arguments.callee.name);
		console.log('downloads', this.downloads);

		const template = $('#download_template').html();
		const handlebars_template = Handlebars.compile(template);
		const result = handlebars_template(this.downloads);
		const html = '<div style="overflow: auto">' + result + '</div>';

		$('#div_downloads').html(html);

		return this;
	},
	drawProducts: function() {
		console.debug('called', arguments.callee.name);
		console.log('products', this.products);

		const template = $('#product_template').html();
		const data1 = this.products;

		let html = '';
		for (const standard_or_ul in data1) {
			const data2 = data1[standard_or_ul];

			html += '<h3>' + standard_or_ul + '</h3>';

			for (const protection in data2) {
				html += '<h4>' + protection + '</h4>';

				const data3 = data2[protection];
				const section = {
					section: data3
				};
				const handlebars_template = Handlebars.compile(template);
				const result = handlebars_template(section);

				html += '<div style="overflow: auto;">';
				html += result;
				html += '</div>';
			}
		}

		$('#div_specs_results').html(html);

		return this;
	},
	drawSingleProduct: function() {
		console.debug('called', arguments.callee.name);

		const num_axis = typeof this?.pn_specs?.num_axis !== 'undefined' ? '_' + this.pn_specs.num_axis + 'axis' : '';

		$('#div_specs_results').html('');

		$.get('/wp-content/themes/densorobotics/template-hbs/product-specifications' + num_axis + '.htm', (template) => {
			const render = Handlebars.compile(template);

			$('#div_specs_results').html(render(this.pn_specs));

			// Jump to hash point.
			window.location.hash = 'nav_tabs';
		});

		return this;
	},
	drawSpecificationFilters: function() {
		console.debug('called', arguments.callee.name);

		const template = $('#filter_template').html();
		const handlebars_template = Handlebars.compile(template);
		const result = handlebars_template(this.limits);
		const html = '<div>' + result + '</div>';

		$('#div_specs').html(html);

		// Change the tab to show the specifications.
		$('#nav_tabs a[href="#specs"]').tab('show');

		// Destroy the tooltips since it messes up on Google Chrome.
		$('#div_specs .tooltips label').tooltip('dispose');

		// Set up tooltips.
		$('#div_specs .tooltips label').tooltip({
			placement: 'top'
		});
		// $('[data-toggle="tooltip"]').tooltip();

		this.setEventAutoComplete();

		this.setEventFilters();

		return this;
	},
	getProductByPartNumber: function(pn) {
		console.debug('called', arguments.callee.name);

		const data = {
			action: 'product_by_part_number',
			pn: pn
		};

		$.ajax({
			beforeSend: () => {
				this.setCursorWait();
			},
			data: data,
			dataType: 'json',
			type: 'GET',
			url: window.ajaxurl
		})
			.done((response) => {
				if (response.status == 'success') {
					this.pn_specs = response.data;
					this.drawSingleProduct();
				}
			})
			.fail(() => { })
			.always(() => {
				this.clearCursorWait();
			});

		return this;
	},
	getReaches: function() {
		console.debug('called', arguments.callee.name);

		const data = {
			action: 'product_reaches',
			filters: this.filters,
			reach: this.reach,
			series: this.series
		};

		$.ajax({
			beforeSend: () => {
				this.setCursorWait();
			},
			data: data,
			dataType: 'json',
			type: 'GET',
			url: window.ajaxurl
		})
			.done((response) => {
				if (response.status == 'success') {
					// get the part numbers for this reach and series
					this.partnumbers = [];

					const partnumbers = response.partnumbers.data;
					for (let i in partnumbers) {
						const row = partnumbers[i];
						this.partnumbers.push(row.part);
					}

					// ----- LIMITS -----
					this.allowed_limits = response.limits_allowed.data;
					this.limits = response.limits.data;

					// draw filters for specifications after the part numbers are filled out
					this.drawSpecificationFilters();

					// get the products for this reach and series
					this.products_count = response.count;
					this.products = response.data;

					this.drawProducts();

					if (typeof response.catalogs !== 'undefined') {
						this.catalogs = response.catalogs.data;

						this.drawCatalogs();
					}

					if (typeof response.downloads !== 'undefined') {
						this.downloads = response.downloads.data;

						this.drawDownloads();
					}
				}
			})
			.fail(() => { })
			.always(() => {
				this.clearCursorWait();
			});

		return this;
	},
	initSection: function() {
		console.debug('called', arguments.callee.name);

		if (typeof window.catalogs !== 'undefined') {
			this.catalogs = window.catalogs;

			this.drawCatalogs();
		}

		if (typeof window.downloads !== 'undefined') {
			this.downloads = window.downloads;

			this.drawDownloads();
		}

		if (typeof window.robot_series !== 'undefined') {
			this.series = window.robot_series;
		}

		Handlebars.registerHelper('if_gt', function(a, b, opts) {
			if (a > b) {
				return opts.fn(this);
			}

			return opts.inverse(this);
		});

		return this;
	},
	selectReach: function() {
		console.debug('called', arguments.callee.name);

		var self = this;

		// remove the active css for all a_reach and btn_reach buttons
		$('.a_reach')
			.parent()
			.removeClass('active')
			.each(function() {
				if (self.reach == $(this).data('value')) {
					$(this).addClass('active');
				}
			});

		$('.btn_reach')
			.removeClass('active')
			.each(function() {
				if (self.reach == $(this).data('value')) {
					$(this).addClass('active');
				}
			});

		this.getReaches();

		return this;
	},
	setEventAutoComplete: function() {
		console.debug('called', arguments.callee.name);

		var self = this;

		$('#partnumber').off();

		$('#partnumber').autoComplete({
			events: {
				search: function(qry, callback) {
					var data = {
						action: 'part_number_ac',
						q: qry,
						reach: self.reach,
						series: self.series
					};

					$.ajax(window.ajaxurl, {
						data: data
					}).done((result) => {
						console.log({ result });

						callback(result);
					});
				}
			},
			minLength: 1,
			noResultsText: 'No part number found.',
			resolver: 'custom'
		});

		$('#partnumber').on('autocomplete.select', (e, item) => {
			e.preventDefault();

			this.getProductByPartNumber(item.id);
		});

		return this;
	},
	setEventFilters: function() {
		console.debug('called', arguments.callee.name);

		var self = this;

		var obj = $('#div_specs');

		var labels = ['degree_of_protection', 'max_payload', 'pnp_or_npn', 'standard_or_ul', 'z_travel'];

		for (var i in labels) {
			var label = labels[i];

			var found = false;

			$.each(obj.find('input[name="' + label + '"]'), function(index) {
				var filter_name = label;
				var filter_value = $(this).val();

				// console.log(filter_name, filter_value);

				// check if the filter is already set
				if (self.filters[filter_name] == filter_value) {
					found = true;

					$(this)
						.prop('checked', true)
						.parent()
						.addClass('active');
				}

				if (filter_value !== 'all') {
					if (filter_name == 'max_payload' || filter_name == 'z_travel') {
						filter_value = parseInt(filter_value);
					}

					if (typeof self.allowed_limits[filter_name] !== 'undefined') {
						var allowed = self.allowed_limits[filter_name];
						// console.log(allowed);

						if ($.inArray(filter_value, allowed) > -1) {
							// enable
							$(this)
								.parent()
								.removeClass('disabled');
							$(this).prop('disabled', false);
							// console.log(filter_name, filter_value, 1);
						} else {
							// disable
							$(this)
								.parent()
								.addClass('disabled');
							$(this).prop('disabled', true);
							// console.log(filter_name, filter_value, 0);
						}
						// console.log(allowed);
					}
				}

				$(this)
					.off()
					.on('click', function(e) {
						e.preventDefault();

						$(this)
							.closest('div')
							.find('label')
							.removeClass('active');
						$(this)
							.prop('checked', true)
							.parent()
							.addClass('active');

						self.filters[filter_name] = $(this).val();

						self.getReaches();
					});
			});

			// console.log(label, 'found', found);

			if (!found) {
				$.each(obj.find('input[name="' + label + '"]'), function(index) {
					if (index == 0) {
						$(this)
							.prop('checked', true)
							.parent()
							.addClass('active');
					}
				});
			}
		}

		return this;
	},
	setEventHandlers: function() {
		console.debug('called', arguments.callee.name);

		$('.a_reach').off('click').on('click', (e) => {
			e.preventDefault();

			this.reach = $(e.currentTarget).parent().data('value');

			this.selectReach();
		});

		$('.btn_reach').off('click').on('click', (e) => {
			e.preventDefault();

			this.reach = $(e.currentTarget).data('value');

			this.selectReach();
		});

		return this;
	}
};

$(function() {
	$.extend(true, RoboBase, Products);

	var products = $.extend(true, {}, RoboBase);
	products.init();
});
